<template>
  <nav class="dynamic-tabs-nav" aria-labelled-by="dynamic-tabs-nav-label">
    <ul class="dynamic-tabs-nav-items">
      <li class="dynamic-tabs-nav-item is-label">
        <span id="dynamic-tabs-nav-label">{{ label }}</span>
      </li>

      <li
        v-for="(link, index) in links"
        :key="link.handle + index"
        class="dynamic-tabs-nav-item"
        :class="{
          'is-active': link.handle === activeLink
        }"
      >
        <a :href="link.url" @click.prevent="handleClick(link.handle)">
          {{ link.title }}
        </a>
      </li>
    </ul>
    <select v-model="selectModel" class="dynamic-tabs-nav-select">
      <option
        v-for="(link, index) in links"
        :key="link.url + index"
        :value="link.handle"
      >
        {{ link.title }}
      </option>
    </select>
  </nav>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    links: {
      type: Array
    },
    activeLink: {
      type: String
    }
  },
  computed: {
    selectModel: {
      get() {
        return this.activeLink;
      },
      set(value) {
        if (value === '*') {
          this.$emit('show-all');
        } else {
          this.$emit('select', value);
        }
      }
    }
  },

  methods: {
    handleClick(value) {
      if (value === '*') {
        this.$emit('show-all');
      } else {
        this.$emit('select', value);
      }
    }
  }
};
</script>
